import Services from './base-services'

const service = new Services('purchase')
import mapParameters from '../utils/map-parameters'

export default {
    getPurchasesByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null,
            size: 100
        })
        return service.get('getPurchasesByUser', params)
    },
    createPurchaseAvatarPack(userId: number|string, packId: number|string) {
        const params = {
            productsType: 'AVATAR_PACK',
            userId,
            packId
        }
        return service.post('createPurchaseList', params)
    },
    createPurchaseBook(userId: number|string, bookId: number|string) {
        const params = {
            productType: 'BOOK',
            user: {
                id: userId
            },
            book :{
                id: bookId
            }
        }
        return service.post('createPurchase', params)
    },
    createPurchaseSkin(userId: number|string, skinId: number|string) {
        const params = {
            productType: 'SKIN',
            user: {
                id: userId
            },
            skin :{
                id: skinId
            }
        }
        return service.post('createPurchase', params)
    }
}
